










import { Vue, Component, Prop } from 'vue-property-decorator'
import { Empty } from 'vant'

@Component({
  components: {
    [Empty.name]: Empty
  }
})
export default class CommonEmptyComponent extends Vue {
  @Prop() readonly image!: any //背景图
  @Prop() readonly message!: string //描述文案
  @Prop() readonly btnTitle!: string //按钮标题
  @Prop({ default: false }) readonly showEmpty!: boolean //展示暂无内容
  @Prop({ default: 500 }) readonly height!: number //高度设置

  get defImage() {
    if (this.image) return this.image

    if (this.showEmpty) {
      return require('@assets/images/search/icon_empty.png')
    }
    return require('@assets/images/search/icon_error.png')
  }

  get defMessage() {
    if (this.message && this.message.length > 0) return this.message

    if (this.showEmpty) {
      return '暂无相关信息哦～'
    }
    return '加载出错，请稍后再试'
  }

  get defBtnTitle() {
    if (this.btnTitle && this.btnTitle.length > 0) return this.btnTitle

    if (this.showEmpty) {
      return ''
    }
    return '重新加载'
  }

  click() {
    this.$emit('reload')
  }
}
